export default "__VITE_ASSET__Jl0tVkbH__"